const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/fields/VersicherungsklasseField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const VersicherungsklasseField = generateMetaKatDropDownField(
    'c32a9a2f-14e0-4b03-a72c-af0d1efc83df',
    'VersicherungsklasseField'
);
